// extracted by mini-css-extract-plugin
export var flex = "sectionReviewForm-module--flex--40960";
export var form = "sectionReviewForm-module--form--26dce";
export var logo = "sectionReviewForm-module--logo--4992d";
export var ratings = "sectionReviewForm-module--ratings--3f1ac";
export var ratingsAndLogo = "sectionReviewForm-module--ratingsAndLogo--65c56";
export var richtext = "sectionReviewForm-module--richtext--18098";
export var section = "sectionReviewForm-module--section--4f354";
export var success = "sectionReviewForm-module--success--d1344";